<div class="container">
  <ghs-header [standalone]="true"></ghs-header>

  <div class="menu">
    <label>
      <span [ghs-label]="'settings.edition'"></span>
      <select [(ngModel)]="edition" (change)="update(); updateQueryParams()">
        <option *ngFor="let edition of gameManager.editions(true)" [value]="edition">
          <span [ghs-label]="'data.edition.' + edition"></span>
        </option>
      </select>
    </label>
  </div>

  <div class="treasures" *ngIf="edition">
    <div class="treasure" *ngFor="let treasure of treasures">
      <span class="index">{{treasure.index}}</span>

      <ghs-treasure-label class="placeholder text-white" [treasure]="treasure" [edition]="edition"></ghs-treasure-label>
    </div>
  </div>
</div>